import React, { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";
import { useApp } from "@/state/AppContext";
import { localized } from "@/theme/tenantTheme";
import { Button } from "@/components/ui/button";
import { EnquirySection } from "@/components/business/EnquirySection";

/** Storefront S5 (gap review item 7): the handoff never shows the big generic "Send this business
 * a message" form in the main flow when a specialised capture already exists on the page (gym has
 * the trial-booking card, ISP the coverage check + plans, solar the service-visit booking) — every
 * `*.dc.html` BODY. `EnquirySection` itself is unchanged; this just gates whether it starts open.
 *
 * Auto-expands the moment `enquiryPrefill` is set — a plan's "Join" CTA or the ISP coverage check
 * scrolls to this section and expects a prefilled form waiting, not a collapsed button (the same
 * mount-timing bug `EnquirySection`'s own docstring calls out as RE-UAT-007; collapsing behind a
 * button reintroduces it if this doesn't also auto-open). */
export function CollapsibleEnquiry({ business, collapsed }) {
  const { t, lang, enquiryPrefill } = useApp();
  const [open, setOpen] = useState(!collapsed);

  useEffect(() => {
    if (enquiryPrefill) setOpen(true);
  }, [enquiryPrefill]);

  if (!collapsed || open) return <EnquirySection business={business} />;

  return (
    <div className="rounded-2xl border border-dashed border-border p-5 text-center">
      <Button
        variant="outline"
        className="gap-2 rounded-full"
        data-testid="storefront-enquiry-expand"
        onClick={() => setOpen(true)}
      >
        <MessageSquare size={15} />
        {t("storefront.enquiryCollapsed.cta", { name: localized(lang, business, "name") || business.name })}
      </Button>
    </div>
  );
}
